import { render } from "./VenueImages.vue?vue&type=template&id=47ed426d"
import script from "./VenueImages.js?vue&type=script&lang=js"
export * from "./VenueImages.js?vue&type=script&lang=js"

import exportComponent from "/github/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__